export class ViewBankDashboard{
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
}
export class PaymentTxnsAmountInputForBoth{
    type: string;
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
}
export class PaymentTxnsAmountOutputForBoth{
    payment_name: string[];
    total_amount: number[];
}
export class PaymentSuccessFailureOutputForBoth{
    payment_name: string[];
    success: number[];
    fail: number[];
}
export class TopRecordsInput{
    recordfor: string;
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
}
export class TopRecordsOutput{
    data_for: string;
    reason: string;
    record_for: string;
    response: string;
    top_records: string[];
}
export class RegisteredBanksInput {
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
}
export class EkpayRegisteredBank {
    fail_rate: number;
    bank_charges: number;
    success_rate: number;
    txns_amount: number;
    selected_pi_name: string;
}

export class RegisteredBanksOutput {
    data_for: string;
    reason: string;
    response: string;
    ekpay_registered_banks: EkpayRegisteredBank[];
}


// WEBPACK FOOTER //
// ./src/app/dashboards/bank-dashboard/input-output-parm.ts